<script lang="ts">
  import { link, navigate } from "svelte-routing"
  import { Button, Card, CardBody, Col, Container, Input, Row } from "sveltestrap"
  import { connected, selectedAccount, web3 } from "svelte-web3"
  import { currentChainId, nfts } from "../stores/store"
  import UploadCard from "../components/UploadCard.svelte"
  import WalletConnect from "../components/WalletConnect.svelte"
  import { ERC721ABI } from "../abis/erc721"
  import { CONFIG } from "../config"
  import { convertIpfsImage, getNftCollection } from "../utils/utils"
  import { writable } from "svelte/store"

  let supportNftList = $currentChainId in [1, '0x1', 3, '0x3', 4, '0x4', 137, '0x89'];
  let nftAddress = '';
  let tokenId = '';

  let nfts = [];

  const checkOwner = async () => {
    const nftContract = new $web3.eth.Contract(ERC721ABI, nftAddress);
    const owner = await nftContract.methods.ownerOf(tokenId).call();
    if ($selectedAccount.toLowerCase() === owner.toLowerCase()) {
      navigate(`/upload/${nftAddress}/${tokenId}`);
    }
  }
  const getOwnedNfts = async () => {
    const fetchURL = `${CONFIG[$currentChainId].ALCHEMY_URL}/getNFTs?owner=${$selectedAccount}`;
    let res = await (await fetch(fetchURL)).json();
    for (let nft of res.ownedNfts) {
      if (nft.id.tokenMetadata.tokenType !== 'ERC721') continue;
      let collection = 'Unknown'
      try {
        const contract = new $web3.eth.Contract(ERC721ABI, nft.contract.address);
        collection = await getNftCollection(contract);
      } catch (e) {
        console.error(e);
      }
      nfts = nfts.concat([{
        address: nft.contract.address,
        id: Number(nft.id.tokenId),
        image: convertIpfsImage(nft.metadata.image),
        collection: collection,
        title: `${collection} #${Number(nft.id.tokenId).toString()}`
      }])
    }
  }

  $: if ($connected && supportNftList) {
    getOwnedNfts()
      .catch((e) => {
        console.error(e);
        supportNftList = false;
    })
  }
</script>

<Row>
  <div class="page-header"/>
</Row>
<Container>
  <Row>
    <Col class="page-title">
      Upload NFT
    </Col>
  </Row>
  {#if $connected}
    {#if supportNftList}
      <Row>
        <Col class="upload-subtitle">
          Select an NFT to list
        </Col>
      </Row>
      <Row cols="{{ xs: 1, sm: 2, md: 3, lg: 4 }}">
        {#each nfts as nft (nft.id)}
          <Col>
            <UploadCard {nft} />
          </Col>
        {/each}
      </Row>
    {:else}
      <Row>
        <Col class="upload-find-title text-center">
          Oops, We hit a snag.
        </Col>
      </Row>
      <Row>
        <Col class="text-center">
          Current wallet wouldn’t allow us showcase your NFTs.<br/>Let us help you locate your NFT manually.
        </Col>
      </Row>
      <Row class="justify-content-center">
        <Col md="8" lg="6">
          <Card class="info-card upload-find-card">
            <CardBody>
              <Row>
                <Col class="upload-find-input-label">
                  NFT Address <span class="negative">*</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input class="upload-find-input" bind:value={nftAddress}/>
                </Col>
              </Row>
              <Row>
                <Col class="upload-find-input-label">
                  Token ID <span class="negative">*</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input class="upload-find-input" bind:value={tokenId}/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button class="button-fill upload-find-button" on:click={checkOwner}>Find my NFT</Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    {/if}
  {:else}
    <Row class="upload-desc justify-content-center">
      <Col class="text-center">
        Connect to your wallet to upload NFTs you own.
      </Col>
    </Row>
    <Row class="justify-content-center">
      <Col class="col-auto">
        <WalletConnect className="upload-connect">
          Connect to a wallet
        </WalletConnect>
      </Col>
    </Row>
  {/if}
</Container>
